import DocViewer, { PDFRenderer, PNGRenderer } from "@cyntler/react-doc-viewer";
import ButtonAHSF from "../../Components/ButtonAHSF";
import "./style.css";
import { useNavigate } from "react-router-dom";
import AddAplicatoionInformation, {
  AgreeTerms,
} from "../../Services/ApplicationInformation/AddAplicationInformation";
// import DocViewer, { PDFRenderer, PNGRenderer } from "cyntler/react-doc-viewer";
import { useDispatch, useSelector } from "react-redux";
import PDF from "./IAGI.pdf";
import $ from "jquery";
import Swal from "sweetalert2";
import { useState } from "react";
import { setRefreshTable } from "../../Redux/Reducers/VariousVariables";
import LoaderAHSF from "../../Components/LoaderAHSF";


const GeneralInstructions = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [canClick, setCanClick] = useState(true);

  const state = useSelector((state) => {
    return {
      ApplicationInformation: state.ApplicationInformation,
      jsonData: state.FetchDataJson,
    };
  });


  console.log(state.jsonData?.JsonData?.UrlDocument,"jhjhjshd");

 // Function to add a new application
const addNewApplication = async () => {
  console.log("malekhosinatdffdfdf",canClick);
  
  if (canClick) { // Ensure the function doesn't run if already processing
    setCanClick(false); // Prevent multiple clicks

    const addapp = await AddAplicatoionInformation(); // Call to add application information
   // console.log(addapp, "addapp");

    // Check if the application was successfully added
    if (addapp.data.success == true) {
      setCanClick(true); // Reset click allowance

      // If no result is returned (empty response)
      if (addapp.data.result?.length == 0) {
        Swal.fire({
          title: addapp.data.message, // Show a message from the server
          icon: "info", // Info icon
          confirmButtonText: "خروج", // Confirmation button text
          cancelButtonText: "الغاء", // Cancel button text
          showCancelButton: false, // No cancel button
          showCloseButton: true, // Allow closing the popup
        }).then((res) => {
          if (res.isConfirmed) { // If user confirms
            window.location.replace("/grants/mainpage"); // Redirect to the main page
          }
        });
      } else {
        // Save the application ID to localStorage
        localStorage.setItem(
          "aI_ApplicationInformationId",
          addapp.data.result
        );

        // Automatically agree to terms with the "approved" status
        const agreed = await AgreeTerms(addapp.data.result, "approved");
        if (agreed) {
          navigate("/grants/ApplicationInformation"); // Redirect to the Application Information page
        }
      }
    }
  }
};
//render after loading ends
  return (
    <div className="AgreeTerms">
      {!state.ApplicationInformation.loadingApplicationInformation ? (
        <div >
          <div className="DocViewerContainer">
            <DocViewer
              className="DocViewer"
              documents={[
                {
                  // uri: state.FetchDataJson.UrlDocument,
                  uri: PDF,
                },
              ]}
              // initialActiveDocument={docs}

              pluginRenderers={[PDFRenderer, PNGRenderer]}
              config={{
                header: {
                  disableHeader: true,
                  disableFileName: true,
                },
               
              }}
            />
          </div>

          <div className="ContainerButtonApproved">
            <div className="SectionLeft">
              <ButtonAHSF
                text="موافق"
                show={true}
                type="submitter"
                title="موافق"
                onClick={async () => {
                  await addNewApplication();
                }}
              />
            </div>
            <div className="SectionLeft">
              <ButtonAHSF
                text="غير موافق"
                show={true}
                type="submitter"
                title="غير موافق"
                onClick={async () => {
                  //   await AgreeTerms(
                  //     localStorage.getItem("aI_ApplicationInformationId"),
                  //     "reject"
                  //   );
                  $(".close-btn").trigger("click");
                }}
              />
            </div>
          </div>
        </div>
      ) : (
        <></>
      )}
      <LoaderAHSF show={!canClick} />
    </div>
  );
};

export default GeneralInstructions;
